import { PeriodPicker, SharedPeriodPickerProps } from './PeriodPicker';
import { formatQuarter, parseQuarter } from './periodRange';

export type QuarterPickerProps = SharedPeriodPickerProps;

export function QuarterPicker(props: QuarterPickerProps) {
  return (
    <PeriodPicker
      {...props}
      type="quarter"
      periodsPerYear={4}
      format={formatQuarter}
      parse={parseQuarter}
      formatGridPeriod={(quarter) => `Q${quarter}`}
    />
  );
}
